/* file description */
import { useEffect, useState } from 'react';
import { UseGetLabelByEdit } from './type';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';
import { COLUMN_FROM } from '../../../effects/consts';

export const useGetLabelByEdit: UseGetLabelByEdit = ({ value, field, API, setOptionList }) => {
  const { detailModule = 'md_cpart_product_base_info' } = field?.bizConfig || {};

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  useEffect(() => {
    if (value) {
      const params: Record<any, any> = {
        moduleID: detailModule,
        namespaceID: 'master_data',
        filter: `product_code in ('${value}')`,
      };
      getModuleRecordListCache(API?.FetchAPI, 'master_data', detailModule, params).then((res: any) => {
        const { set = [] } = res || {};
        const listData = set.map((r: any) => convert(r));
        if (listData?.length > 0) {
          setOptionList([{
            name: listData[0]?.product_name,
            code: value,
          }]);
        }
      });
    }
  }, [value]);
};
